import React from 'react';
import {
    Typography,
    Box,
    //   Fade,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';

const SectionTitle = ({
    title,
    subtitle,
    variant = 'h4',
    align = 'center',
    showUnderline = true,
    sx = {},
    ...props
}) => {
    const { i18n } = useTranslation();
    const theme = useTheme();

    return (
        // <Fade in={true} timeout={500}>
        <Box
            sx={{
                textAlign: align,
                mb: 4,
                ...sx
            }}
            {...props}>
            <Typography
                variant={variant}
                fontWeight="bold"
                sx={{
                    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                    color: 'transparent',
                    textShadow: 'none',
                    position: 'relative',
                    display: 'inline-block',
                    ...(showUnderline && {
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            bottom: -2,
                            width: '60px',
                            height: '3px',
                            background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.accent.main} 100%)`,
                            borderRadius: 2,
                            mx: 'auto',
                            transform: 'translateX(-50%)',
                            left: align === 'center' ? '50%' : 0,
                        },
                    }),
                }}
            >
                {title?.[i18n.language] || title?.en || title}
            </Typography>

            {subtitle && (
                <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ mt: 1 }}
                >
                    {subtitle?.[i18n.language] || subtitle?.en || subtitle}
                </Typography>
            )}
        </Box>
        // {/* </Fade> */}
    );
};

export default SectionTitle;
